export default __webpack_public_path__ + "static/media/afterlife-u.a82419fe.png";